import { useLocaleContext } from '../components/i18n/LocaleProvider';

export function useLocale() {
  return useLocaleContext();
}
